module.exports = __webpack_public_path__ + "static/media/upi_apps.76558761.svg";